import { z } from "zod";
import { resourceIdSchema } from "./common.schemas";

export const markAsReadInputSchema = z.object({
  // Notifications have no aggregate identity; this addresses an infrastructure row.
  // See scripts/identity-ratchet-allowlist.md#resource-id-schema-6--by-design-not-deferred-debt.
  communicationId: resourceIdSchema,
});
export type MarkAsReadInput = z.infer<typeof markAsReadInputSchema>;

export const markAsUnreadInputSchema = z.object({
  // Notifications have no aggregate identity; this addresses an infrastructure row.
  // See scripts/identity-ratchet-allowlist.md#resource-id-schema-6--by-design-not-deferred-debt.
  communicationId: resourceIdSchema,
});
export type MarkAsUnreadInput = z.infer<typeof markAsUnreadInputSchema>;

export const markAllAsReadInputSchema = z.object({
  recipientRef: z.string(),
});
export type MarkAllAsReadInput = z.infer<typeof markAllAsReadInputSchema>;

export const getPrefsInputSchema = z.object({
  recipientRef: z.string(),
});
export type GetPrefsInput = z.infer<typeof getPrefsInputSchema>;

export const setPrefsInputSchema = z.object({
  recipientRef: z.string(),
  muted: z.array(z.string()),
});
export type SetPrefsInput = z.infer<typeof setPrefsInputSchema>;

/** Client-facing input for `setPrefs` — `recipientRef` is the acting
 * practitioner (`ctx.profileRef`), never client-supplied, so one
 * practitioner can never mute another's notifications. */
export const setPrefsClientInputSchema = z.object({
  muted: z.array(z.string()),
});
